/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { ErrorHandler } from '../core/error.service';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { OpenErpService } from '../../models/OpenErpService';


/**
 * Api services for the `OpenErpService` model.
 *
 * **Details**
 *
 * Service to perform generic OpenERP actions such as login, read, search
 */
@Injectable()
export class OpenErpServiceApi extends BaseLoopBackApi {

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http,  models, auth, errorHandler);
  }

  /**
   * Perform OpenERP login to obtain the user token
   *
   * @param {object} data Request data.
   *
   *  - `username` – `{string}` - 
   *
   *  - `password` – `{string}` - 
   *
   *  - `hostId` – `{string}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `OpenErpService` object.)
   * </em>
   */
  public login(username: any, password: any, hostId: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/OpenErpService/login";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof username !== 'undefined' && username !== null) _urlParams.username = username;
    if (typeof password !== 'undefined' && password !== null) _urlParams.password = password;
    if (typeof hostId !== 'undefined' && hostId !== null) _urlParams.hostId = hostId;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Request OpenERP search action to fetch object ids given a filter
   *
   * @param {object} req 
   *
   * @param {string} resourceName Name of OpenERP resource. ie: res.partner
   *
   * @param {object} filter Juggler filter
   *
   * @returns {object[]} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `OpenErpService` object.)
   * </em>
   */
  public search(req: any = {}, resourceName: any, filter: LoopBackFilter = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/OpenErpService/search";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof resourceName !== 'undefined' && resourceName !== null) _urlParams.resourceName = resourceName;
    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Request OpenERP read action to fetch objects given a list of object ids and object fields to select
   *
   * @param {object} req 
   *
   * @param {string} resourceName Name of OpenERP resource. ie: res.partner
   *
   * @param {any} ids List of object ids to filter
   *
   * @param {any} fields List of object field names to select
   *
   * @returns {object[]} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `OpenErpService` object.)
   * </em>
   */
  public read(req: any = {}, resourceName: any, ids: any, fields: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/OpenErpService/read";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof resourceName !== 'undefined' && resourceName !== null) _urlParams.resourceName = resourceName;
    if (typeof ids !== 'undefined' && ids !== null) _urlParams.ids = ids;
    if (typeof fields !== 'undefined' && fields !== null) _urlParams.fields = fields;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `OpenErpService`.
   */
  public getModelName() {
    return "OpenErpService";
  }
}



// WEBPACK FOOTER //
// ./src/sdk/services/custom/OpenErpService.ts